export default {
  id: "audit-logs",
  title: "Audit Logs",
  section: "Administration",
  order: 96,
  keywords: "audit logs history who changed what before after diff security IP investigate",
  body: `
## What it is

The Audit Logs page is the system's memory: every meaningful action —
creates, updates, deletes, sensitive reads, logins gone wrong — recorded
automatically with who, what, when, and from where. When someone asks "who
changed this?", the answer is here.

## What each entry captures

- **Who**: the user (email) and their **IP address**.
- **When**: timestamp in Denver time.
- **What**: action type (color-coded — create green, update blue, delete
  red, error orange, read grey), the resource and its ID, the request
  method and path, and a human-readable details line.
- **The change itself**: the list of changed fields and full
  **before/after snapshots** of the data.
- **Outcome**: success or failure.

Click any entry for the detail view — a summary plus a field-level
**Before/After diff** (old values in red, new in green), or the raw
snapshots when a field diff isn't available.

## Step by step: common investigations

**"Who changed this shift's clock-out time?"**
1. Filter Resource to shifts.
2. Search the shift's ID (it's on the shift's detail or in report rows).
3. Open the update entries and read the before/after diff — the old and
   new times are right there, with the editor's name and the change reason
   they entered.

**"Who approved that time off / deleted that record?"**
1. Filter by the resource (time off, authorizations, etc.) and Action
   (update/delete).
2. Narrow with the date range and the requester's email in search.

**"Was there suspicious activity?"**
1. Filter Status to **Failure** — failed operations and permission
   violations stand out.
2. Check unfamiliar IP addresses on sensitive actions.

## Notes

- Logging is automatic and can't be turned off per-user; there is nothing
  to maintain on this page.
- Admin shift edits always carry the **change reason** the admin typed, so
  write reasons you'll be glad to read six months later.
`,
};
